// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PWBhLjhzc8NimAdqySAo{width:532px;max-width:100%}.PWBhLjhzc8NimAdqySAo .DGc3QWWsstIQHwqYA8B8{padding:11px 8px 11px 12px}.PWBhLjhzc8NimAdqySAo .ECYq6gWXxQITpateIAvr{padding:12px 8px 12px 12px}.b2dPJMVN6XgKYnJ7McLE,.S5jmQiFqEvMloWwtFEIa{margin-top:24px}.p14OcRsAPjoT3dZz_V7J{align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `PWBhLjhzc8NimAdqySAo`,
	"selectPadding": `DGc3QWWsstIQHwqYA8B8`,
	"inputPadding": `ECYq6gWXxQITpateIAvr`,
	"secondContactCheckbox": `b2dPJMVN6XgKYnJ7McLE`,
	"confirmed": `S5jmQiFqEvMloWwtFEIa`,
	"confirmDesc": `p14OcRsAPjoT3dZz_V7J`
};
export default ___CSS_LOADER_EXPORT___;
